export default function parseAddress(address) {
    // Regex mis à jour pour capturer les numéros avec suffixes, les boîtes et les noms de rue
    const regex = /^(\d+[A-Za-z]?)?\s*([^\d]+?)\s*(\d+[A-Za-z]?)?(?:\s*[,.-]?\s*(boite|boîte|box|bte)?\s*(\d+|[A-Za-z]))?$/i;
    
    const match = address.match(regex);
    
    if (!match) {
      return { streetNumber: null, streetName: null, boxNumber: null };
    }
  
    const [, streetNumberStart, streetName, streetNumberEnd, boxLabel, boxNumber] = match;
  
    // Priorité au numéro de rue de début, sinon celui de fin
    const streetNumber = streetNumberStart || streetNumberEnd || null;
  
    return {
      streetNumber: streetNumber || null, 
      streetName: streetName ? streetName.trim() : null,
      boxNumber: boxLabel ? boxNumber : null 
    };
  }